module.exports = __webpack_public_path__ + "static/media/CL.c1554c95.png";